
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconBellSelector = "fhi-icon-bell";

/**
 * ## FhiIconBell
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-bell
 * @element fhi-icon-bell
 */
@customElement(FhiIconBellSelector)
export class FhiIconBell extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M13.043 20.639a.75.75 0 0 1 1.314.722 2.692 2.692 0 0 1-4.623.156l-.091-.156-.034-.069a.75.75 0 0 1 1.308-.719l.04.066.086.134a1.19 1.19 0 0 0 2-.134m4.2-12.9A5.25 5.25 0 0 0 6.75 8c0 3.61-.775 5.987-1.592 7.484a9 9 0 0 1-.469.766h14.622a9 9 0 0 1-.47-.766C18.026 13.987 17.25 11.611 17.25 8zM18.75 8c0 3.39.725 5.513 1.408 6.766.343.628.68 1.045.918 1.297a3 3 0 0 0 .338.311l.004.003h-.001A.75.75 0 0 1 21 17.75H3a.75.75 0 0 1-.417-1.373h-.001l.004-.003.062-.05c.06-.05.156-.136.276-.262.238-.251.575-.668.918-1.296C4.525 13.513 5.25 11.389 5.25 8a6.75 6.75 0 1 1 13.5 0"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
